<section class="auth-card" aria-labelledby="auth-substitute-title">
  <form class="auth-form" [formGroup]="form" (ngSubmit)="submit()">
    <div class="auth-card__header">
      <pa-button
        icon="pi pi-arrow-left"
        variant="outlined"
        size="small"
        severity="secondary"
        aria-label="Назад"
        (click)="back()"
      />
      <div class="auth-card__intro">
        <h1
          class="auth-card__title auth-card__title--left"
          id="auth-substitute-title"
        >
          Вход подменным сотрудником
        </h1>
        <p class="auth-card__subtitle">
          ПИН-код указан в профиле сотрудника. Если вы не знаете его, обратитесь к управляющему.
        </p>
      </div>
    </div>

    <div class="auth-form-fields">
      <pa-input
        #substituteLoginInput
        type="text"
        formControlName="login"
        placeholder="Почта или телефон..."
        [showClear]="false"
      />

      <div
        class="auth-code-field"
        [class.auth-email-field--error]="showPinError"
      >
        <pa-input
          type="password"
          formControlName="code"
          inputmode="decimal"
          placeholder="Введите 4 цифры"
          [maxLength]="4"
          [showClear]="false"
        />
        <p *ngIf="showPinError" class="auth-code-error" role="alert">
          {{ pinErrorText }}
        </p>
      </div>

      <pa-button
        label="Войти"
        [fullWidth]="true"
        styleClass="auth-submit"
        [disabled]="isSubmitDisabled()"
        (click)="submit()"
      />
    </div>

    <app-support-link-v2 />
    <p class="auth-version">ver. {{ environment.appVer }}</p>
  </form>
</section>
